import {
  initialState,
  Actions,
  State,
  GET_ALL_PERIODICS_CHECKS,
  GET_ALL_PERIODICS_CHECKS_SUCCESS,
  GET_ALL_PERIODICS_CHECKS_ERROR,
  RESET_GET_ALL_PERIODICS_CHECKS,
} from '../../types/periodic-check/get-all'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ALL_PERIODICS_CHECKS:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case GET_ALL_PERIODICS_CHECKS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case GET_ALL_PERIODICS_CHECKS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_GET_ALL_PERIODICS_CHECKS:
      return initialState
    default:
      return state
  }
}

export default reducers
